import PublicNav from '@/components/PublicNav';
import PublicFooter from '@/components/PublicFooter';
import XVAssistWidget from '@/components/XVAssistWidget';
import DOMPurify from 'dompurify';

export default function PublicPageShell({ eyebrow, title, intro, children, dataTestId }) {
  return (
    <div className="min-h-screen bg-black text-white" data-testid={dataTestId}>
      <PublicNav />
      <section className="pt-32 pb-12 px-4">
        <div className="max-w-5xl mx-auto">
          {eyebrow && <p className="text-[#A3FF00] text-xs font-bold tracking-[0.25em] mb-3">{eyebrow}</p>}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black tracking-tight mb-5">{title}</h1>
          {intro && <p className="text-lg text-zinc-400 max-w-3xl leading-relaxed">{intro}</p>}
        </div>
      </section>
      <div className="px-4 pb-16">
        <div className="max-w-5xl mx-auto">
          {children}
        </div>
      </div>
      <PublicFooter />
      <XVAssistWidget forcePublic />
    </div>
  );
}

export function FeatureGrid({ items, cols = 'md:grid-cols-2' }) {
  return (
    <div className={`grid ${cols} gap-4`}>
      {items.map((it) => {
        const Icon = it.icon;
        return (
          <div key={it.t} className="bg-[#0a0a0a] border border-zinc-800 hover:border-[#A3FF00]/40 transition-colors rounded-lg p-6">
            {Icon && <Icon className="w-7 h-7 text-[#A3FF00] mb-3" strokeWidth={1.5} />}
            <p className="font-bold text-white">{it.t}</p>
            {it.d && <p className="text-sm text-zinc-400 mt-2 leading-relaxed">{it.d}</p>}
          </div>
        );
      })}
    </div>
  );
}

export function BulletList({ items, accent = '#A3FF00' }) {
  return (
    <ul className="space-y-3">
      {items.map((b) => (
        <li key={b} className="flex gap-3 text-zinc-300 leading-relaxed">
          <span className="mt-2 w-1.5 h-1.5 rounded-full shrink-0" style={{ background: accent }} />
          <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(b, { ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'a', 'span'], ALLOWED_ATTR: ['href', 'class'] }) }} />
        </li>
      ))}
    </ul>
  );
}

export function SectionHeading({ children, eyebrow }) {
  return (
    <div className="mb-6 mt-12">
      {eyebrow && <p className="text-[#A3FF00] text-xs font-bold tracking-[0.25em] mb-2">{eyebrow}</p>}
      <h2 className="text-2xl md:text-3xl font-heading font-bold">{children}</h2>
    </div>
  );
}
